import React from 'react'
import A from '../components/A'
import { withIntl } from '../i18n'
import { withPrefix } from 'gatsby'
import Layout from '../components/layout'
import Input from '../components/Input'
import Footer from '../components/FooterExtended'

import {
  validateEmail
} from '../utils'

import styles from '../styles/contatti.module.scss'

const POST_URL = 'https://services.gbr.systems/systems/website/contact'

class Contatti extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      send: false,
      name: '',
      surname: '',
      phone: '',
      address: '',
      msg: '',
      privacy: false,
      notvalid: false
    }
  }
  send(event) {
    event.preventDefault();
    event.stopPropagation();
    const {
      name,
      surname,
      phone,
      address,
      msg,
      privacy
    } = this.state

    let valid = true;

    if (
      !validateEmail(address) ||
      name === '' ||
      surname === '' ||
      msg === '' ||
      !privacy
    ) {
      valid = false
      this.setState({
        notvalid: true
      })
    } else {
      this.setState({
        notvalid: false,
      })
    }
    if ( valid ) {
      let formBody = []
      let dataBody = {
        name: encodeURIComponent(name),
        surname: encodeURIComponent(surname),
        phone: encodeURIComponent(phone),
        msg: encodeURIComponent(msg),
        privacy: encodeURIComponent(privacy),
        address: encodeURIComponent(address),
        lang: `it`,
        email: ``
      }
      for ( let prop in dataBody ) {
        formBody.push(
          prop + `=` + dataBody[prop]
        )
      }
      fetch(POST_URL,
        {
          method: "POST",
          body: formBody.join(`&`),
          headers:
          {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
      }).then(() => this.setState({ send: true, }));
    }
  }

  getPrivacySlug = () => {
    if (!this.props.pageContext) {
      return "/it/privacy-policy"
    }
    const { locale } = this.props.pageContext

    const { edges } = this.props.data.allCockpitPages

    for ( let i = 0; i < edges.length ; i++ ) {
      const node = edges[i].node.entry

      if (node.isPrivacyPolicy) {
        return '/' + locale + '/' + node.Slug
      }
    }
    return "/it/privacy-policy"
  }

  render() {
    const {
      send,
      name,
      surname,
      address,
      msg,
      privacy,
      notvalid
    } = this.state
    const {
      data
    } = this.props
    return (
      <Layout
        pageTitle="Contatti"
        noMinHeight
        footerRender={() => <Footer infos={data.allCockpitPages.edges} />}
        pageDescription="Analizzare le esigenze e la situazione attuale del cliente, al fine di poter consigliare soluzioni soluzioni progettate specificatamente a sua misura"
        ogtags={[
          {
            name: 'title',
            content: 'GBR System™ - Richiesta di informazioni',
          },
          {
            name: 'description',
            content: 'Analizzare le esigenze e la situazione attuale del cliente, al fine di poter consigliare soluzioni soluzioni progettate specificatamente a sua misura',
          },
          {
            name: 'image',
            content: withPrefix('/seo/gbr-systems-business-contact.jpg')
          }
        ]}
      >
        <div
          className={"text-container " + styles.contacts}
        >
          <h1>Contatti</h1>
          <div className={styles.container}>
            <div className={styles.col1}>
              <h2>SEDI</h2>
              <p style={{ marginTop: 30 }}>
                Via Vincenzo Monti, 47<br />
                20123 Milano, Italy
              </p>
              <p style={{marginTop: 30}}>
                Gallerie Vidussi, 10<br />
                30027 S. Donà di Piave<br />
                Venezia, Italy
              </p>
              <A href="tel:00390256567119">
                <p style={{ marginTop: 30 }}>
                  02 5656 7119
                </p>
              </A>
            </div>
            <div className={styles.col2} onClick={() => notvalid ? this.setState({ notvalid: false }) : {}}>
              <h2>SCRIVICI</h2>
              {
                send ?
                  <p>Grazie per averci contattato, ti rispondermo al più presto</p>
                :
                <form autoComplete="off" id="form-data">
                  <div
                    className={styles.form}
                  >
                    <div className={styles.inputCol}>
                      <Input name="name" invalid={notvalid ? name === '' : false} onChange={(event) => this.setState({name: event.target.value})} placeholderText="Nome" />
                    </div>
                    <div className={styles.inputCol}>
                      <Input name="surname" invalid={notvalid ? surname === '' : false} onChange={(event) => this.setState({ surname: event.target.value })} placeholderText="Cognome" />
                    </div>
                    <div className={styles.inputCol}>
                      <Input name="phone" onChange={(event) => this.setState({ phone: event.target.value })} placeholderText="Telefono" />
                    </div>
                    <div className={styles.inputCol}>
                      <Input name="address" invalid={notvalid ? !validateEmail(address) : false} onChange={(event) => this.setState({ address: event.target.value })} placeholderText="Email" />
                    </div>
                    <div style={{width: "100%", marginTop: 20}}>
                      <Input
                        name="msg"
                        invalid={notvalid ? msg === '' : false}
                        textarea
                        onChange={(event) => this.setState({ msg: event.target.value })}
                        placeholderText="Messaggio"
                      />
                    </div>
                    <div style={{display: `none`}}>
                      <Input name="email" />
                    </div>
                  </div>
                  <br />
                  <input onChange={(event) => this.setState({ privacy: event.target.checked })} type="checkbox" name="informativa" id="informativa" />
                  <label
                    htmlFor="informativa"
                    style={{
                      color: notvalid && !privacy ? 'red' : ''
                    }}
                  >
                    Accetto
                      <A
                        target="_blank"
                        href={this.getPrivacySlug()}
                        className={styles.linkContatti}
                      >
                        &nbsp;l'informativa della privacy
                      </A>
                  </label>
                  <br /><br />
                  {/*
                    <input type="checkbox" name="aggiornamenti" id="aggiornamenti" />
                    <label htmlFor="aggiornamenti">Ricevi aggiornamenti</label>
                    <br /><br />
                  */}
                  <A><button onClick={(e) => this.send(e)} className="primary">Invia</button></A>
              </form>
            }
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
export const query = graphql`
  query {
    allCockpitPages {
      edges {
        node {
          id
          entry {
            Slug
            Title
            isPrivacyPolicy
          }
        }
      }
    }
  }
`
export default withIntl(Contatti)
